import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SiteHeaderDesktop from './SiteHeaderDesktop';
var SiteHeader = function () {
    var isMobile = useContext(MobileContext);
    return React.createElement(React.Fragment, null, isMobile ? null : React.createElement(SiteHeaderDesktop, null));
};
SiteHeader.displayName = 'SiteHeader';
export default SiteHeader;
//# sourceMappingURL=SiteHeader.js.map